import { render, staticRenderFns } from "./ClaimInfo.vue?vue&type=template&id=63b6e87e&"
import script from "./ClaimInfo.vue?vue&type=script&lang=js&"
export * from "./ClaimInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClaimInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports